{
    "ReportlistMyreportlist": "Minha lista de relatórios",
    "ReportlistAddreport": "Adicionar relatório",
    "ReportlistDeletereport": "Excluir relatório",
    "ReportlistMoreoptions": "Mais opções",
    "ReportlistModifyreport": "Modificar relatório",
    "ReportlistCopyreport": "Copiar relatório",
    "ReportlistRenamefolder": "Renomear pasta",
    "ReportlistRenamereport": "Renomear relatório",
    "NoreportsconfiguredText": "Nenhum relatório configurado.",
    "ReportlistRecyclebin": "Lixeira de reciclagem",
    "ReportlistEmptyrecyclebin": "Lixeira vazia",
    "ReportlistRestoreallreports": "Restaurar todos os relatórios",
    "ReportlistRestorereport": "Restaurar relatório",
    "ReportlistDeletereportsinfolder": "Excluir conteúdo da pasta",
    "ReportlistRestorereportsinfolder": "Restaurar conteúdo da pasta",
    "ReportlistNotAllCompleted": "{} de {} relatórios selecionados foram movidos para a lixeira.",
    "ReportlistOutof": "fora de",
    "ReportlistNoreportswererestored": "Nenhum relatório foi restaurado.",
    "ReportlistReportwasrestored": "O relatório foi restaurado.",
    "ReportlistReportswererestored": "{} relatórios foram restaurados.",
    "ReportlistXoutofyselectedreportswererestored": "{} de {} relatórios selecionados foram restaurados.",
    "ReportlistRestoregenericfailurereason": "Os relatórios com falha podem já ter sido restaurados ou excluídos permanentemente.",
    "ReportlistNoreportsweremovedtobin": "Nenhum relatório foi movido para a lixeira.",
    "ReportlistReportwasmovedtobin": "O relatório foi movido para a lixeira.",
    "ReportlistReportsweremovedtobin": "{} relatórios foram movidos para a lixeira.",
    "ReportlistXoutofyselectedreportsweremovedtobin": "{} de {} relatórios selecionados foram movidos para a lixeira.",
    "ReportlistMovetobingenericfailurereason": "Os relatórios com falha podem já ter sido movidos para o compartimento.",
    "ReportlistThirtydaysremaining": "Isso permanecerá em sua lixeira por 30 dias ou até ser esvaziado.",
    "ReportlistBeendeleted": "foi deletado.",
    "ReportlistNoreportsweredeletedpermanently": "Nenhum relatório foi excluído permanentemente.",
    "ReportlistReportwasdeletedpermanently": "O relatório foi excluído permanentemente.",
    "ReportlistReportsweredeletedpermanently": "{} relatórios foram excluídos permanentemente.",
    "ReportlistXoutofyselectedreportsweredeletedpermanently": "{} de {} relatórios selecionados foram excluídos permanentemente.",
    "ReportlistDeletepermanentlygenericfailurereason": "Os relatórios com falha podem já ter sido excluídos ou restaurados permanentemente e não estão mais na lixeira.",
    "ReportlistMoveToBinCondition": "No futuro, não me mostre esta caixa de diálogo.",
    "ReportlistNoreportswerecopied": "Nenhum relatório foi copiado.",
    "ReportlistReportwascopied": "O relatório foi copiado.",
    "ReportlistReportswerecopied": "{} relatórios foram copiados.",
    "ReportlistXoutofyselectedreportswerecopied": "{} de {} relatórios selecionados foram copiados.",
    "ReportlistCopygenericfailurereason": "Os relatórios com falha podem já ter sido movidos para o compartimento.",
    "NAME": "LanguageMyReportList",
    "ReportlistAdddefaultreport": "Adicionar relatório predefinido",
    "ReportListCopyReportsSuccessfulMessage": "Copiou com êxito {} relatório(s)",
    "ReportlistOverrideExistingReport": "Assinale se pretende substituir os Relatórios existentes.",
    "ReportlistReportsKeptForThirtyDays": "Os relatórios anulados serão guardados na Reciclagem durante 30 dias ou até serem esvaziados."
}